import React, { Component } from "react";
import { connect } from "react-redux";
import TitleBar from "../_common/TitleBar";
import AdminProjects from "./AdminProjects/AdminProjects";
import AdminUnits from "./AdminUnits/AdminUnits";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AdminUsers from "./AdminUsers/AdminUsers";
import { getPermissions } from "../../_helpers/authorize";
import { DOCTYPE } from "../../_constants/docTypeConstants";
import { docPermConstants } from "../../_constants/permissionConstants";
import AdminContractors from "./AdminContractors/AdminContractors";
import AdminUsersV2 from "./AdminUsers/AdminUsersV2";
import AdminWebhooks from "./AdminWebhooks/AdminWebhooks";

class AdminMain extends Component {
  state = {
    permissions: null,
    selectedTask: "users",
    selectedTabId: "users",
  };

  tabs = [
    { tabId: "users", link: "#", label: "Users" },
    { tabId: "units", link: "#", label: "Units" },
    { tabId: "projects", link: "#", label: "Projects" },
    { tabId: "fieldOffices", link: "#", label: "Field Offices" },
    { tabId: "contractors", link: "#", label: "Contractors" },
    { tabId: "webhooks", link: "#", label: "Webhooks", sysAdminOnly: true },
  ];

  componentDidMount() {
    const { user } = this.props;
    const permissions = getPermissions({
      user,
      docType: DOCTYPE.ADMIN_TASKS,
      projectId: 0,
      creatorId: 0,
    });
    this.setState({ permissions });
  }

  selectTab = (selectedTabId) => this.setState({ selectedTabId });

  handleTitleBarAction = () => {};
  handleClick_taskLink = (e) => {
    e.preventDefault();
    this.setState({ selectedTask: e.target.name });
  };

  renderTaskBody = () => {
    const { permissions, selectedTabId } = this.state;
    const { tab } = this.props;
    switch (selectedTabId) {
      case "projects":
        return <AdminProjects tabId={tab.tabId} permissions={permissions} />;
      case "users":
        return <AdminUsersV2 tabId={tab.tabId} permissions={permissions} />;
      case "units":
        return <AdminUnits tabId={tab.tabId} permissions={permissions} />;
      case "fieldOffices":
        return <h2>Field Offices</h2>;
      case "contractors":
        return <AdminContractors tabId={tab.tabId} permissions={permissions} />;
      case "webhooks":
        return permissions && permissions.includes(docPermConstants.DELETE) ? (
          <AdminWebhooks tabId={tab.tabId} permissions={permissions} />
        ) : (
          ""
        );
      default:
        return "";
    }
  };

  render() {
    const { selectedTabId, permissions } = this.state;
    // Only SYSADMIN has DELETE on ADMIN_TASKS (DISTADMIN/office admin does not) - use it to
    // gate tabs that should be visible to system admins only, e.g. Webhooks.
    const isSysAdmin = !!(permissions && permissions.includes(docPermConstants.DELETE));
    const visibleTabs = this.tabs.filter((t) => !t.sysAdminOnly || isSysAdmin);
    return (
      <React.Fragment>
        <TitleBar
          titleText={"Administration Tasks"}
          handleTitleBarAction={this.handleTitleBarAction}
        />
        <div className="row mx-0">
          <div className="col-12 px-2">
            <AdminTabs
              tabs={visibleTabs}
              selectTab={this.selectTab}
              selectedTabId={selectedTabId}
            />
            <div className="tab-content pa-tab-content">
              <div
                className="tab-pane fade show active border border-secondary pa-tab-pane p-3"
                role="tabpanel"
              >
                {this.renderTaskBody()}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="row mr-0">
          <div className="col-md-2 pr-0">
            <div className="row">
              <div className="col">
                <div className="card mx-2 mb-2 bg-lightgray">
                  <div className="card-body p-3">
                    <h6>
                      <FontAwesomeIcon icon="tools" className="fa-fw mr-2" />
                      Tasks
                    </h6>
                    <hr className="mt-1 mb-2" />
                    <button
                      type="button"
                      name="users"
                      id="users"
                      className="btn btn-link pl-1"
                      onClick={this.handleClick_taskLink}
                    >
                      Users
                    </button>
                    <br />
                    <button
                      type="button"
                      name="units"
                      id="units"
                      className="btn btn-link pl-1"
                      onClick={this.handleClick_taskLink}
                    >
                      Units
                    </button>
                    <br />
                    <button
                      type="button"
                      name="projects"
                      id="projects"
                      className="btn btn-link pl-1"
                      onClick={this.handleClick_taskLink}
                    >
                      Projects
                    </button>
                    <br />
                    <button
                      type="button"
                      name="fieldOffices"
                      id="fieldOffices"
                      className="btn btn-link pl-1"
                      onClick={this.handleClick_taskLink}
                      disabled={true}
                    >
                      Field Offices
                    </button>
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-10 pl-2">{this.renderTaskBody()}</div>
        </div> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.authentication.user,
});

export default connect(mapStateToProps)(AdminMain);

function AdminTabs(props) {
  const { tabs, selectTab, selectedTabId } = props;

  const renderTab = (tab) => {
    return (
      <li key={tab.tabId} className="nav-item">
        <div
          className={`nav-link border border-secondary border-bottom-0 pointer-cursor ${
            tab.tabId === selectedTabId ? "active admin-tab--border" : ""
          }`}
          id={tab.tabId + "_tab"}
          data-toggle="tab"
          role="tab"
          onClick={() => selectTab(tab.tabId)}
        >
          {tab.label}
        </div>
      </li>
    );
  };

  return (
    <ul className="nav nav-tabs border-0" role="tablist">
      {tabs.map((tab) => renderTab(tab))}
    </ul>
  );
}
